import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

import moduleAuth from './auth/moduleAuth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,

    // authentication and current user app
    'auth': moduleAuth,
  },
  strict: process.env.DEV,
})

